/**
 * Shared data for the live search activity animation ("Name X. searched flights to Destination").
 * Uses only destinations from our airport list (cities with real airports airlines fly to).
 * 200+ first names × 26 initials × 300+ airport cities = 1.5M+ unique combinations.
 */

import { AIRPORT_CITIES } from '@/components/search/AirportInput';

export const firstNames = [
  'Alex', 'Jordan', 'Taylor', 'Morgan', 'Casey', 'Riley', 'Jamie', 'Avery', 'Quinn', 'Sage',
  'Skyler', 'Dakota', 'Parker', 'Cameron', 'Reese', 'Charlie', 'Sam', 'Kai', 'River', 'Rowan',
  'Dylan', 'Blake', 'Harley', 'Phoenix', 'Emerson', 'Drew', 'Ash', 'Finley', 'Hayden', 'Jesse',
  'Kendall', 'Logan', 'Marley', 'Noah', 'Ocean', 'Peyton', 'Remy', 'Sawyer', 'Winter', 'Aria',
  'Blair', 'Eden', 'Ellis', 'Gray', 'Lane', 'Lex', 'Max', 'Nico', 'Reign', 'Scout',
  'Emma', 'Liam', 'Olivia', 'Ethan', 'Sophia', 'Mason', 'Ava', 'Lucas', 'Isabella', 'Jackson',
  'Mia', 'Aiden', 'Harper', 'Elijah', 'Amelia', 'James', 'Evelyn', 'Benjamin', 'Abigail', 'William',
  'Emily', 'Michael', 'Elizabeth', 'Oliver', 'Sofia', 'Jacob', 'Madison', 'Daniel', 'Scarlett', 'Henry',
  'Victoria', 'Sebastian', 'Grace', 'Matthew', 'Chloe', 'David', 'Zoe', 'Joseph', 'Lily', 'Carter',
  'Hannah', 'Wyatt', 'Layla', 'Gabriel', 'Addison', 'Julian', 'Natalie', 'Luke', 'Audrey', 'Jack',
  'Brooklyn', 'Leo', 'Bella', 'Owen', 'Claire', 'Ryan', 'Penelope', 'Miles', 'Stella', 'Nathan',
  'Violet', 'Isaac', 'Aurora', 'Joshua', 'Savannah', 'Lincoln', 'Hazel', 'Christian', 'Lucy', 'Hunter',
  'Ellie', 'Connor', 'Paisley', 'Eli', 'Nora', 'Landon', 'Maya', 'Adrian', 'Piper', 'Jonathan',
  'Ruby', 'Sadie', 'Colton', 'Kennedy', 'Brayden', 'Madelyn', 'Grayson', 'Skylar', 'Jaxon', 'Hailey',
  'Cooper', 'Aaliyah', 'Easton', 'Eva', 'Bentley', 'Naomi', 'Nolan', 'Alice', 'Carson', 'Sadie',
  'Roman', 'Ariana', 'Elias', 'Allison', 'Tristan', 'Gianna', 'Declan', 'Serenity', 'Damian', 'Nevaeh',
  'Brody', 'Camila', 'Jace', 'Arianna', 'Bryson', 'Genesis', 'Micah', 'Elena', 'Axel', 'Melanie',
  'Santiago', 'Mackenzie', 'Kayden', 'Reagan', 'Gavin', 'Adalynn', 'Brantley', 'Liliana', 'Asher', 'Jade',
  'Ryder', 'Valentina', 'Jason', 'Willow', 'Cole', 'Emilia', 'Dominic', 'Quinn', 'Tyler', 'Natalia',
  'Brandon', 'Delilah', 'Kevin', 'Brooklyn', 'Preston', 'Vivian', 'Austin', 'Madeline', 'Oscar', 'Brielle',
  'Maddox', 'Rylee', 'Jasper', 'Sienna', 'Levi', 'Aubrey', 'Silas', 'Clara', 'Ezra', 'Hadley',
  'Theo', 'Kinsley', 'Finn', 'Peyton', 'Beckett', 'Autumn', 'Zachary', 'Jasmine', 'Tucker', 'Reese',
  'Graham', 'Londyn', 'Maxwell', 'Morgan', 'Harrison', 'Sawyer', 'Bennett', 'Marley', 'Everett', 'Emery',
  'Wesley', 'Teagan', 'Weston', 'Kennedy', 'Braxton', 'Quinn', 'Brooks', 'Skyler', 'Xavier', 'Dakota',
  'Reed', 'Phoenix', 'Griffin', 'River', 'Bryce', 'Sage', 'Blake', 'Rowan', 'Hayden', 'Finley',
  'Kyle', 'Aspen', 'Marcus', 'Sierra', 'Vincent', 'Paige', 'Miles', 'Riley', 'Leo', 'Jordan',
  'Felix', 'Alex', 'Carter', 'Taylor', 'Owen', 'Casey', 'Hudson', 'Avery', 'Luca', 'Quinn',
  'Archer', 'Blake', 'Jude', 'Cameron', 'Knox', 'Reese', 'River', 'Charlie', 'Phoenix', 'Sam',
];

export const lastInitials = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

/** Destinations from our airport list - only cities with real airports airlines fly to */
export const destinations = AIRPORT_CITIES;

/**
 * Generate a random "Name X. searched flights to Destination" string.
 */
export function generateSearchActivity() {
  const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
  const lastInitial = lastInitials[Math.floor(Math.random() * lastInitials.length)];
  const city = destinations[Math.floor(Math.random() * destinations.length)];
  return `${firstName} ${lastInitial}. searched flights to ${city}`;
}
